import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { DeviceDetectionService } from "../services/device-detection.service";

/**
 * Guard que bloqueia acesso em dispositivos mobile
 * Redireciona para página orientando uso em desktop
 */
export const mobileGuard = () => {
  const deviceDetection = inject(DeviceDetectionService);
  const router = inject(Router);

  if (deviceDetection.isMobile()) {
    router.navigateByUrl("/mobile-block");
    return false;
  }

  return true;
};
